<template>
    <md-toolbar id="main-navbar"
                md-elevation="0"
                class="md-primary md-fixed-top md-toolbar-fixed"
                :class="{'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute}">

        <div class="md-toolbar-row">
            <div class="md-toolbar-section-start">
                <h3 class="md-title font-normal">{{ $route.meta.route.label }}</h3>
            </div>
            <div class="md-toolbar-section-end">
                <md-button
                    class="md-just-icon md-round md-simple md-toolbar-toggle"
                    :class="{ toggled: $sidebar.showSidebar }"
                    @click="toggleSidebar"
                >
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </md-button>

                <div class="md-collapse">

                    <autocomplete
                        class="md-field md-autocomplete search md-theme-default md-inline md-clearable md-autocomplete-box"
                        style="margin-top: 4px;"
                        :search="search" :debounceTime="300"
                        :get-result-value="displayValue"
                        placeholder="Recherche" aria-label="Recherche"
                        @submit="goToRessource"
                    >
                        <template #result="{ result, props }">
                            <li v-bind="props" class="autocomplete-result">
                                <button class="md-list-item-button md-list-item-container md-button-clean">
                                    <div class="md-list-item-content md-ripple">
                                        <div class="md-theme-default">
                                            {{ result.text }}
                                        </div>
                                    </div>
                                </button>
                            </li>
                        </template>
                    </autocomplete>

					<md-list>
						<md-list-item @mousedown="goToRoute($event, 'Demand Add')">
							<p style="margin: 0">Nouvelle demande</p>
						</md-list-item>

						<md-list-item @mousedown="goToRoute($event, 'Add Intervention')">
							<p style="margin: 0">Nouvelle intervention</p>
						</md-list-item>

                        <md-list-item href="mailto:support@nixie.fr">
                            <p style="margin: 0">Assistance</p>
                        </md-list-item>

                        <md-list-item href="#/">
                            <p style="margin: 0">Session : {{ sessionTime }}</p>
                        </md-list-item>

						<md-list-item @mousedown="goToRoute($event, 'Profile')">
							<p style="margin: 0">{{ user }}</p>
						</md-list-item>

                        <md-list-item @click="logout">
                            <i class="md-icon fas fa-sign-out-alt"></i>
                        </md-list-item>
                    </md-list>
                </div>
            </div>
        </div>
    </md-toolbar>
</template>

<script>
import {mapState} from 'vuex'
import Autocomplete from '@trevoreyre/autocomplete-vue'
import routerMixin from "@/mixins/router-mixin"

export default {
    name: 'TopNavbar',
    components: {
        Autocomplete
    },
    mixins: [ routerMixin ],
    data() {
        return {
            timer: true,
            selectedResult: null,
            results: [],
        };
    },
    computed: mapState({
        user: state => state.profile.me.last_name,
        isIdle() {
            return this.$store.state.idleVue.isIdle
        },
        sessionTime() {
            let hours = Math.trunc((this.$store.state.profile.session / 60) / 60)
            let minutes = Math.floor((this.$store.state.profile.session / 60) % 60).toString()
            return hours + 'h' + (minutes.length === 1 ? '0' + minutes : minutes) + 'min'
        }
    }),
    methods: {
        toggleSidebar() {
            this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
        },
        minimizeSidebar() {
            if (this.$sidebar) {
                this.$sidebar.toggleMinimize();
            }
        },
        logout() {
            this.$store.dispatch("logout")
        },
        async search(value) {
            if (value === null || value.length < 2) {
                return []
            } else {
                return new Promise(async resolve => {
                    const {data} = await this.$store.dispatch('functions/search', {search: value})
                    resolve(data)
                })
            }
        },
        displayValue(value) {
            return '';
        },
        goToRessource(result) {
            if (result.route === "Site Details") {
                this.$router.push({name: result.route, params: {id: result.idClient, idSite: result.id}})
            } else {
                this.$router.push({name: result.route, params: {id: result.id}})
            }
        }
    },
    created() {
        let count = setInterval(() => {
            if (this.isIdle) {
                this.$store.dispatch("profile/updateSession")
                if (this.$store.getters["profile/sessionTime"] === 0) {
                    clearInterval(count)
                    this.logout()
                }
            } else {
                this.$store.dispatch("profile/resetSession")
            }
        }, 60000);
    },
};
</script>
<style lang="scss" scoped>
::v-deep {
    .md-collapse {
        .md-list {
            .md-list-item, .md-list-item-button {
                transition: all 150ms ease-in;
                color: inherit !important;
                font-weight: 400 !important;
                font-size: 14px !important;
                overflow: visible !important;
                border-radius: 3px !important;
                position: relative !important;
                display: block !important;
                padding: 0 !important;
                text-decoration: none !important;

                svg {
                    margin: 0 !important;
                    line-height: 30px;
                    min-width: 16px !important;
                    font-size: 16px !important;
                }
            }

            .md-list-item:hover {
                background: rgba(200, 200, 200, 0.2) !important;
            }

            .md-list-item-button:hover {
                background-color: transparent !important;
            }
        }

        .md-field.md-autocomplete {
            min-width: 350px;

            .autocomplete {
                width: 100%;

                .autocomplete-input {
                    margin-top: 0 !important;
                    font-size: 14px !important;
                    line-height: 1.4 !important;
                    padding: 7px 30px 7px 16px;
                    height: 36px;
                    width: 100%;
                    -webkit-text-fill-color: #000 !important;
                    -webkit-appearance: none;
                    -moz-appearance: none;
                    appearance: none;
                    display: block;
                    flex: 1;
                    color: #000;
                    border: none;
                    transition: .4s cubic-bezier(.25, .8, .25, 1);
                    transition-property: all;
                    transition-property: font-size, padding-top, color;
                    font-family: inherit;
                    position: relative;
                }

                .autocomplete-result-list {
                    padding: 6px 0;
                    max-width: 950px !important;
                    width: 100% !important;
                    min-width: 950px !important;
                    margin-top: 20px !important;
                    max-height: 45vh !important;
                    background: #fff !important;
                    -webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
                    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
                    border-radius: 3px !important;
                    overflow-y: scroll;
                    transition: transform .2s cubic-bezier(.25, .8, .25, 1), opacity .3s cubic-bezier(.25, .8, .25, 1);
                    will-change: opacity, transform, top, left !important;

                    .autocomplete-result {
                        color: #000 !important;
                        margin: 0 0.3125rem 5px;

                        height: auto;
                        position: relative;
                        z-index: 2;

                        :last-child {
                            margin-bottom: 0;
                        }

                        .md-list-item-button {
                            .md-ripple {
                                min-height: 38px;
                                font-size: 13px;
                                padding: 10px 15px;
                                border-radius: 3px;

                                .md-theme-default {
                                    font-size: 13px;
                                }
                            }
                        }

                        .md-list-item-button:hover {
                            background: rgba(200, 200, 200, 0.2) !important;
                        }
                    }
                }
            }
        }
    }
}
</style>
